/* unplugin-vue-components disabled */import { render } from "./Error.vue?vue&type=template&id=5db1efc2&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import "./Error.vue?vue&type=style&index=0&id=5db1efc2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@5.9.3__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db1efc2"]])

export default __exports__